/**
 * Client-portal-only area: studio users are sent to Today instead. Used
 * inside ProtectedRoute (signed in) and around the portal.access check.
 */

import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { useAuth } from '@/hooks';

import { isClientRole, STUDIO_HOME } from './portalRole';

export function PortalOnly({ children }: { children: ReactNode }) {
  const { user } = useAuth();
  if (!isClientRole(user?.role)) return <Navigate to={STUDIO_HOME} replace />;
  return <>{children}</>;
}
